// components/PersonalFilters.jsx
import React from 'react';
import { districts } from '../constants/personalConstants';
import '../StatisticaPersonal.css';

const PersonalFilters = ({
    selDist,
    loading,
    onDistrictChange,
    onShowData
}) => {
    return (
        <div className="filter-row">
            <div className="row">
                <div className="col-md-4 filter-section">
                    <label className="filter-label">Район:</label>
                    <select 
                        className="filter-select" 
                        value={selDist} 
                        onChange={onDistrictChange}
                        disabled={loading}
                    >
                        {districts.map((dist, index) => (
                            <option key={index} value={dist}>{dist}</option>
                        ))}
                        <option value='all'>всі райони</option>
                    </select>
                </div>
                
                <div className="col-md-4 filter-section">
                    <label className="filter-label">&nbsp;</label>
                    <button 
                        className="filter-button" 
                        onClick={onShowData} 
                        disabled={loading}
                    >
                        {loading ? 'Завантаження...' : 'Показати'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PersonalFilters;